import { Component, OnInit } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import flags from './flags';

@Component({
  selector: 'country-select',
  template: `
    <mat-select [formControl]="formControl" [(value)]="selected">
      <mat-option value="en-US">
        <span style="margin-right:5px;">
          {{ flag('US') }}&nbsp;
        </span>
        United States
      </mat-option>
      <mat-option value="en-GB">
        <span style="margin-right:5px;">
          {{ flag('GB') }}&nbsp;
        </span>
        United Kingdom
      </mat-option>
    </mat-select>
  `,
  standalone: false
})
export class CountrySelectComponent extends FieldType<FieldTypeConfig> implements OnInit {

  selected: string;

  ngOnInit() {
    this.selected = this.formControl.value;
  }

  flag(countryCode: string) {
    if (!flags[countryCode]) {
      return;
    }
    return flags[countryCode].emoji;
  }
}
